import { apiClient } from "../../lib/api-client";
import { API_PATHS } from "../../config/api";
import {
  CrossProjectTestBuild,
  OverviewSummary,
  RecentBuild,
} from "./types";

/**
 * Cross-project aggregates. Every call is scoped server-side to the projects the
 * caller can access; an account with no grants gets empty lists and zeros.
 * Contract: .docs/BACKEND_REQUIREMENTS.md.
 */
export interface AggregateService {
  getOverviewSummary(): Promise<OverviewSummary>; // GET api/v1/overview/summary
  getRecentBuilds(limit: number): Promise<RecentBuild[]>; // GET api/v1/uploads/recent
  listAllTestBuilds(): Promise<CrossProjectTestBuild[]>; // POST api/v1/test-builds/all-items
}

interface OverviewSummaryResponse {
  variants_count?: number;
  builds_this_week?: number;
  builds_last_week?: number;
  test_builds_expiring_24h?: number;
}

export const aggregateService: AggregateService = {
  getOverviewSummary: async () => {
    const s = await apiClient.get<OverviewSummaryResponse>(API_PATHS.OVERVIEW_SUMMARY);
    return {
      variantsCount: s?.variants_count ?? 0,
      buildsThisWeek: s?.builds_this_week ?? 0,
      buildsLastWeek: s?.builds_last_week ?? 0,
      testBuildsExpiring24h: s?.test_builds_expiring_24h ?? 0,
    };
  },

  getRecentBuilds: async (limit) => {
    const rows = await apiClient.get<RecentBuild[]>(API_PATHS.UPLOADS_RECENT, {
      params: { limit },
    });
    return Array.isArray(rows) ? rows : [];
  },

  // The route returns a bare array, unlike test-builds/items which nests its
  // list under data.data.
  listAllTestBuilds: async () => {
    const rows = await apiClient.post<CrossProjectTestBuild[]>(
      API_PATHS.TEST_BUILD_ALL_ITEMS,
      {}
    );
    return Array.isArray(rows) ? rows : [];
  },
};

export default aggregateService;
